export default (function (_ref) {
  var request = _ref.request;
  return {
    thirdCertAdd: function thirdCertAdd(data) {
      return request({
        url: '/auth/thirdCert',
        method: 'post',
        data: data
      });
    },
    thirdCertModify: function thirdCertModify(data) {
      return request({
        url: "/auth/thirdCert/".concat(data.id),
        method: 'put',
        data: data
      });
    },
    thirdCertRenewal: function thirdCertRenewal(handleId, data) {
      return request({
        url: "/auth/thirdCert/".concat(handleId, "/renewal"),
        method: 'put',
        params: data
      });
    },
    thirdCertDel: function thirdCertDel(id) {
      return request({
        url: "/auth/thirdCert/".concat(id),
        method: 'delete'
      });
    },
    thirdCertQuery: function thirdCertQuery(data) {
      return request({
        url: '/auth/thirdCert',
        method: 'get',
        params: data
      });
    },
    thirdCertDetail: function thirdCertDetail(id) {
      return request({
        url: "/auth/thirdCert/".concat(id),
        method: 'get'
      });
    },
    thirdCertPublicKey: function thirdCertPublicKey(id) {
      return request({
        url: "/auth/thirdCert/".concat(id, "/publicKey"),
        method: 'get'
      });
    }
  };
});